module.exports = __webpack_public_path__ + "static/media/ic-company.683b19cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-company.svg
// module id = 615
// module chunks = 14